import { BlockContentContext } from '../../BlockContent.utils';
import { MainAndHouseholdMembersListSerializer } from './components/MainAndHouseholdMembersList';
import { MembershipOverviewSerializer } from './components/MembershipOverview';
import { AccordionSerializer } from './components/Accordion';
import { NumberOfUsedRoadAssistanceSerializer } from './components/NumberOfRoadsideAssistance/NumberOfRoadAssistance';
import { ActiveChargingTagsSerializer } from './components/ActiveChargingTags';
import { TableSerializer } from './components/Table/Table';
import { IframeSerializer } from './components/Iframe';
import { ImageSerializer } from './components/Image';
import { ImagesSerializer } from './components/Images';
import { TestCollectionSerializer } from './components/TestCollection';
import { VideoSerializer } from './components/Video';
import { QuizSerializer } from './components/Quiz';
import { QuoteSerializer } from './components/Quote';
import { SocialProofSerializer } from './components/SocialProof';
import { PodcastSerializer } from './components/Podcast';
import { InternalLinkSerializer } from './components/InternalLink';
import { ExternalLinkSerializer } from './components/ExternalLink';
import { CtaButtonLinkSerializer } from './components/CtaButtonLink';
import { CtaFileLinkSerializer } from './components/CtaFileLink';
import { CampaignBlockSerializer } from './components/CampaignBlock';
import { CarLoanCalculatorSerializer } from './components/CarLoanCalculator';
import { InsuranceCalculatorSerializer } from './components/InsuranceCalculator';
import { IdpCountriesListSerializer } from './components/IdpCountriesList';
import { HighChartsSerializer } from './components/HighCharts';
import { VehicleInspectionSerializer } from './components/VehicleInspection/VehicleInspection';
import { OilChangeCalculatorSerializer } from './components/OilChangeCalculator/OilChangeCalculator';
import { WindShieldWiperChangeCalculatorSerializer } from './components/WiperChangeCalculator/windshieldWiperChangeCalculator';
import { AnchorSerializer } from './components/Anchor';
import { CodeTypesSerializer } from './components/CodeTypes';
import { MembershipValidUntilSerializer } from './components/MembershipValidUntil/MembershipValidUntil';
import { ParallaxSerializer } from './components/Parallax';
import { PortraitsWithTextSerializer } from './components/portraitsWithText';
import { ReferencedComponentSerializer } from './components/ReferencedComponentSerializer';
import { CtaGlobalBlockSerializer } from './components/CtaGlobalBlock';
import { DocumentsBlockSerializer } from './components/DocumentsBlock';
import { ImageCarouselSerializer } from './components/ImageCarouselSerializer';
import { WideImageSerializer } from './components/WideImageSerializer';
import { InfoBoxSerializer } from './components/InfoBox';
import { DoubleImageSerializer } from './components/DoubleImage/DoubleImageSerializer';
import NumberedListSerializer from './components/NumberedListSerializer';
import ArticleListSerializer from './components/ArticleListSerializer';
import { FeaturedVehicleResultSerializer } from './components/FeaturedVehicleResultSerializer/FeaturedVehicleResultSerializer';
import { TestResultSerializer } from './components/TestResultSerializer';
import TravelSuggestionSerializer from './components/TravelSuggestionSerializer';
import { WeatherForecastsSerializer } from './components/WeatherForecastsSerializer';
import { AltitudeChartSerializer } from './components/AltitudeChartSerializer';
import { RouteMapSerializer } from './components/routeMapSerializer';
import { MembershipValidUntilGreenBadgeSerializer } from './components/MembershipValidUntilGreenBadge/MembershipValidUntilGreenBadge';
import { YoutubeSerializer } from './components/YoutubeSerializer';
import { FormSerializer } from '../Form/FormSerializer';
import { DataWrapperSerializer } from './components/DataWrapper/DataWrapper';
import { InformationUserInteractionSerializer } from './components/InformationUserInteraction';
import { TextWithEndDateSerializer } from './components/TextWithEndDate';
import { TextWithEmailSerializer } from './components/TextWithEmail';
import { GreenBoxWithMembersListAndEndDateSerializer } from './components/GreenBoxWithMembersListAndEndDate/GreenBoxWithMembersListAndEndDate';
import { TextWithHouseholdMemberSerializer } from './components/TextWithHouseholdMember';
import { VippsLoginBlock } from '../../../SectionBlocks/blocks/VippsLogin';
import { InfoMessageBoxSerializer } from './components/InfoMessageBox/InfoMessageBox';
import { CtaButtonInternalLinkSerializer } from './components/CtaButtonInternalLink';
import { AccordionListBlockSerializer } from './components/AccordionList';
import { PayWallSerializer } from './components/PayWall';
import { WarningUserInteractionSerializer } from './components/WarningUserInteraction';
import { ProsAndConsSerializer } from './components/ProsAndConsSerializer';
import { StepByStepListSerializer } from './components/StepByStepListSerializer';
import { ModularButtonBlockSerializer } from './components/ModularButtonSerializer';
import { ConsumerTestProductListSerializer } from './components/ConsumerTestProductList/ConsumerTestProductList';
import { CallButtonBlockSerializer } from './components/CallButton';
import { SeparatorLineBlockSerializer } from './components/SeparatorLineBlock';
import { FAQGlobalReferenceSerializer } from './components/FAQGlobalReference/FAQGlobalReference';
import { CtaButtonBodySerializer } from './components/CtaButtonBody';
import { PollSerializer } from './components/Poll/PollSerializer';
import { CompetitionSerializer } from './components/Competition/CompetitionSerializer';
import { DynamicFormSelectorSerializer } from './components/DynamicFormSelectorSerializer';
import { ShortsCarouselSerializer } from './components/ShortsCarouselSerializer';

export const types = (context: BlockContentContext = BlockContentContext.Stripped) => ({
  accordeon: AccordionSerializer(context), // TODO: consistency in APIs, accordeonComponent in articles / accordeon in product
  accordionList: AccordionListBlockSerializer(context),
  accordeonComponent: AccordionSerializer(context),
  activeChargingTags: ActiveChargingTagsSerializer(context),
  altitudeChart: AltitudeChartSerializer(),
  anchor: AnchorSerializer(context),
  articleList: ArticleListSerializer(context),
  bodyFeaturedVehicleTestResult: FeaturedVehicleResultSerializer(),
  bodyTestResult: TestResultSerializer(context),
  campaignBlockComponent: CampaignBlockSerializer(),
  carLoanCalculator: CarLoanCalculatorSerializer(context),
  code: CodeTypesSerializer(context),
  consumerTestProductList: ConsumerTestProductListSerializer(context),
  ctaButtonLinkComponent: CtaButtonLinkSerializer(context),
  ctaButtonBody: CtaButtonBodySerializer(context),
  ctaButtonInternalLinkComponent: CtaButtonInternalLinkSerializer(context),
  ctaExternalLinkComponent: ExternalLinkSerializer(context),
  ctaFileLinkComponent: CtaFileLinkSerializer(context),
  ctaGlobalBlock: CtaGlobalBlockSerializer(context),
  ctaInternalLink: InternalLinkSerializer(context),
  ctaInternalLinkComponent: InternalLinkSerializer(context),
  dataTableComponent: TableSerializer(context),
  dataWrapperComponent: DataWrapperSerializer(context),
  documentsBlock: DocumentsBlockSerializer(context),
  doubleImage: DoubleImageSerializer(),
  dynamicForm: FormSerializer(context),
  dynamicFormSelectorReference: DynamicFormSelectorSerializer(context),
  highcharts: HighChartsSerializer(context),
  ifkCountriesList: IdpCountriesListSerializer(context),
  iframeComponent: IframeSerializer(context),
  imageCarousel: ImageCarouselSerializer(context),
  imageComponent: ImageSerializer(context),
  imagesComponent: ImagesSerializer(context),
  infoBox: InfoBoxSerializer(context),
  insuranceCalculator: InsuranceCalculatorSerializer(context),
  membershipValidUntil: MembershipValidUntilSerializer(),
  membershipValidUntilGreenBadge: MembershipValidUntilGreenBadgeSerializer(),
  membershipOverview: MembershipOverviewSerializer(),
  informationUserInteraction: InformationUserInteractionSerializer(),
  warningUserInteraction: WarningUserInteractionSerializer(),
  textWithEndDate: TextWithEndDateSerializer(),
  textWithEmail: TextWithEmailSerializer(),
  textWithHouseholdMember: TextWithHouseholdMemberSerializer(),
  mainAndHouseholdMembersList: MainAndHouseholdMembersListSerializer(),
  greenBoxWithMembersListAndEndDate: GreenBoxWithMembersListAndEndDateSerializer(),
  numberOfUsedRoadAssistance: NumberOfUsedRoadAssistanceSerializer(context),
  numberedListWithImage: NumberedListSerializer(context),
  oilChangeCalculator: OilChangeCalculatorSerializer(context),
  podcastEpisode: PodcastSerializer(context),
  portraitsWithText: PortraitsWithTextSerializer(context),
  quizComponent: QuizSerializer(context),
  quoteComponent: QuoteSerializer(context),
  socialProofComponent: SocialProofSerializer(context),
  referencedComponent: ReferencedComponentSerializer(context),
  routeMap: RouteMapSerializer(),
  scrollableTextBlocksWithBackgroundImages: ParallaxSerializer(context),
  testCollectionComponent: TestCollectionSerializer(context),
  travelSuggestion: TravelSuggestionSerializer(),
  vehicleInspection: VehicleInspectionSerializer(context),
  videoComponent: VideoSerializer(context),
  weatherForecasts: WeatherForecastsSerializer(),
  wideImage: WideImageSerializer(context),
  windshieldWiperChangeCalculator: WindShieldWiperChangeCalculatorSerializer(context),
  youtubeEmbed: YoutubeSerializer(context),
  youtubeShorts: ShortsCarouselSerializer(context),
  vippsLogin: VippsLoginBlock,
  infoMessageBox: InfoMessageBoxSerializer(),
  prosAndCons: ProsAndConsSerializer(context),
  paywallReference: PayWallSerializer(context),
  stepBystepList: StepByStepListSerializer(context),
  modularButton: ModularButtonBlockSerializer(context),
  callButtonComponent: CallButtonBlockSerializer(),
  separatorLine: SeparatorLineBlockSerializer(),
  faqGlobalReference: FAQGlobalReferenceSerializer(context),
  pollReference: PollSerializer(context),
  competitionReference: CompetitionSerializer(context),
});
